import { useEffect } from "react";
import { useSetRecoilState } from "recoil";

import {
  editFormDataAF,
  IRideDto,
  RideCrudModeKeyTuple,
  useTimezone,
} from "@ryde/shared";

import { useCrudEditContext } from "../../contexts";
import { useNewRideTemplate } from "./use-new-ride-template";
import { useRideFormCleanup } from "./use-ride-form-cleanup";

export const useRideFormPrepare = (): void => {
  const {
    data: { dto, isEdit, isDuplicate },
  } = useCrudEditContext<IRideDto>();
  const { timezone } = useTimezone();
  const { getNewRideTemplate } = useNewRideTemplate();
  const { cleanupRideFormStateAtoms } = useRideFormCleanup();

  const setRideDto = useSetRecoilState<Partial<IRideDto> | undefined>(
    editFormDataAF(RideCrudModeKeyTuple),
  );

  useEffect(() => {
    /* initial cleanup of previous form state values  */
  }, [cleanupRideFormStateAtoms]);

  useEffect(() => {
    if (!isEdit && !isDuplicate && dto === undefined) {
      const fetchTemplate = async (): Promise<void> => {
        const template = await getNewRideTemplate({});
        setRideDto(template);
      };

      fetchTemplate();
    }
  }, [dto, getNewRideTemplate, isDuplicate, isEdit, setRideDto, timezone]);
};
